import { http } from "services/http";

import type {
  FaqCategoriesResponse,
  FaqCategoryAddRequest,
  FaqCategoryShowResponse,
  FaqCategoryUpdateRequest,
  FaqIdRequest,
  FaqIdResponse,
  FaqListResponse,
  FaqPost,
  FaqSaveRequest,
} from "models/faq.model";

export const faqApi = {
  saveFaq: (data: FaqSaveRequest) => http.quiet().post<FaqIdResponse>("/api/faq/add", { ...data }),
  updateFaq: (data: FaqSaveRequest) => http.quiet().post("/api/faq/update", { ...data }),
  getFaq: () => http.quiet().get<FaqListResponse>("/api/faq"),
  getFaqPost: (data: FaqIdRequest) => http.quiet().post<FaqPost>("/api/faq/show", { ...data }),
  deleteFaqPost: (data: FaqIdRequest) => http.quiet().post("/api/faq/delete", { ...data }),
  getCategories: () => http.quiet().post<FaqCategoriesResponse>("/api/faq/categories-list", {}),
  getCategory: (data: FaqIdRequest) =>
    http.quiet().post<FaqCategoryShowResponse>("/api/faq/category-show", { ...data }),
  updateCategory: (data: FaqCategoryUpdateRequest) =>
    http.quiet().post<FaqIdResponse>("/api/faq/category-update", { ...data }),
  saveCategory: (data: FaqCategoryAddRequest) =>
    http.quiet().post<FaqIdResponse>("/api/faq/category-add", { ...data }),
  deleteCategory: (data: FaqIdRequest) => http.quiet().post("/api/faq/category-delete", { ...data }),
  // `importFile` appended to a FormData.
  saveImportFile: (data: FormData) =>
    http.quiet().post("/api/faq/import", data, { headers: { contentType: "multipart/form-data" } }),
};
